
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isOpen: !this.data.collapsed,
    }
  },

  computed: {
    firstRowIsHeader() {
      if (typeof this.data?.content !== 'string') {
        return false
      }
      return this.data.content.includes('<th')
    },
  },
}
